(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/oddset-categorized/assets/javascripts/handle-most-played-response.js') >= 0) return;  svs.modules.push('/widgets/oddset-categorized/assets/javascripts/handle-most-played-response.js'); 'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createInit;

if (svs.isServer) {
  var initBox = require('../../../../components/sport/match-init-box-light/assets/javascripts/match-init-box.js');

  createInit = initBox.createInit;
} else {
  createInit = svs.sport.matchInitBoxLight.createInit;
} 


var mapDraw = function mapDraw(draw) {
  var leagueName = draw.draw.league.uniqueLeagueName;

  if (!leagueName) {
    leagueName = draw.draw.league.name;
  }

  return _objectSpread({}, draw, {
    url: "/oddset/externalplay?draw=".concat(draw.draw.drawNumber, "&event=").concat(draw.event.eventNumber, "&outcome=&addToBetslip=false&search=").concat(encodeURIComponent(leagueName))
  });
};

var handleMostPlayedResponse = function handleMostPlayedResponse(_ref) {
  var draws = _ref.draws,
      sport = _ref.sport;
  var filteredDraws = draws.filter(function (draw) {
    var isDrawListItem = draw && draw.event && draw.event.isListEvent;
    var isCorrectSport = !sport || draw && draw.draw && draw.draw.sport && draw.draw.sport.id === sport;
    return isDrawListItem && isCorrectSport;
  });
  var slicedDraws = filteredDraws.slice(0, 12);
  var mappedDraws = slicedDraws.map(function (draw, index) {
    return {
      draw: mapDraw(draw),
      initObject: draw ? createInit(draw.draw) : null,
      trackingId: "mest-spelade-".concat(draw.draw.sport.name.toLowerCase(), "-").concat(index + 1)
    };
  });
  return mappedDraws;
};

if (svs.isServer) {
  module.exports = {
    handleMostPlayedResponse: handleMostPlayedResponse,
    mapDraw: mapDraw
  };
} else {
  setGlobal('svs.widget.oddset_categorized.mapDraw', mapDraw);
  setGlobal('svs.widget.oddset_categorized.handleMostPlayedResponse', handleMostPlayedResponse);
}
 })(window);